import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTmn = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#tmn_svg__a)'>
      <path fill='#5C4BAB' d='M24 12q0 12-12 12T0 12 12 0t12 12' />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M12.25 8.896a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0'
        clipRule='evenodd'
      />
      <path
        fill='#fff'
        d='M10.25 7.396a1.5 1.5 0 0 0-1.221 2.372c.08.112.082.269-.015.366a.75.75 0 0 0 1.06 1.06c.66-.66 1.676-1.245 1.676-2.298a1.5 1.5 0 0 0-1.5-1.5'
      />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M5.735 8.791a1 1 0 0 1 .681 1.24c-.656 2.257-.46 3.19.058 3.685.3.286.828.559 1.76.751.927.191 2.158.284 3.766.284s2.84-.093 3.765-.284c.933-.192 1.462-.465 1.761-.751.518-.495.714-1.428.058-3.685a1 1 0 1 1 1.92-.559c.652 2.242.849 4.31-.597 5.69-.682.651-1.625 1.034-2.738 1.264-1.119.23-2.505.325-4.169.325s-3.05-.094-4.17-.325c-1.112-.23-2.055-.613-2.737-1.264-1.446-1.38-1.25-3.448-.597-5.69a1 1 0 0 1 1.24-.68'
        clipRule='evenodd'
      />
    </g>
    <defs>
      <clipPath id='tmn_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgTmn)
export default ForwardRef
